import React, { ElementType } from 'react';
import { Link } from 'react-router-dom';
import { Shelf } from '@src/remotes/Shelf';
import { Typography } from '@guildeducationinc/recess';
import { useBookmarkActions } from '@src/hooks';
import { useMemberExperienceAuth } from '@guildeducationinc/auth-frontend-tools';
import { getUserValuesForPath } from '@src/constants/getUserValuesForPath';
import { useBookmarks } from '../Providers/BookmarksProvider';
import { useRecommendations } from '../Providers/RecommendationsProvider';
import styles from './CoachRecsShelf.module.scss';

export const CoachRecsShelf: React.FC = () => {
	const { bookmarks } = useBookmarks();
	const { updateBookmark } = useBookmarkActions();
	const { getAccessToken, getIdToken, userFromIdToken: user } = useMemberExperienceAuth();
	const authUser = getUserValuesForPath(user);

	const { recommendationsData } = useRecommendations();
	const coachRecs = recommendationsData?.coachRecommendations;
	const coachMessage = recommendationsData?.coachMessage?.message || null;

	const coachRecsUuids = coachRecs?.map(rec => rec.uuid);

	return (
		<div className={styles.coachRecsShelf} data-testid='coachrecs-shelf'>
			<Shelf
				LinkComponent={Link as unknown as ElementType}
				bookmarks={bookmarks}
				getAccessToken={getAccessToken}
				getIdToken={getIdToken}
				product='catalog'
				programUuids={coachRecsUuids}
				shelfType='coach_recs_shelf'
				subhead={
					coachMessage ? (
						<Typography testid='coach-message' variant='body2'>
							<span className={styles.message}>Message from your coach:</span> {coachMessage}
						</Typography>
					) : null
				}
				updateBookmark={updateBookmark}
				user={authUser}
			/>
		</div>
	);
};
